export const getTurnOrderFromPlayer = (playerId, turnOrder) => {
    const currentIndex = turnOrder.indexOf(playerId);

    // Возвращаем часть с текущего индекса до конца + часть от начала до текущего индекса
    return [...turnOrder.slice(currentIndex), ...turnOrder.slice(0, currentIndex)];
}